import { gql } from '@apollo/client';
export const LOAD_FIELDS = gql`
  fragment LoadFields on LoadDto {
    name
    processType
    archiveId
    status
    timestamp
  }
`;
export const LOAD_TYPE_FIELDS = gql`
  fragment LoadTypeFields on LoadTypeDto {
    id
    name
    description
  }
`;